<template>
  <router-view />
</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
* {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.button.glass {
  position: relative;
  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    animation: glass 1.5s infinite;
    background: left / auto 100% no-repeat url("./assets/img/gif_button.png");
  }
  @keyframes glass {
    0% {
      left: 0;
    }
    50% {
      left: 100%;
      opacity: 0;
    }
    100% {
      left: 100%;
      opacity: 0;
    }
  }
}
</style>
